<template>
  <div>
    <b-container class="home-container text-left">
      <b-row class="mb-4">
        <b-col sm="12" md="8">
          <h1>Díjmentes vállalkozásfejlesztési szolgáltatások</h1>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="9">
          <p>
            A vállalkozások számára számos olyan szolgáltatás áll rendelkezésre, amelyeket uniós vagy hazai forrásból
            támogatott projektek keretében kínálnak számukra, ezért térítésmentesen elérhetőek. Az üzleti tervezéstől a
            nemzetközi piacra lépésen keresztül a generációváltásig díjmentes mentorálás, tanácsadás, képzés vehető
            igénybe a cég minden egyes élethelyzetére. A fókuszált támogatások célja a különböző életszakaszok
            nehézségein való átjutás megkönnyítése, a növekedés elősegítése, illetve az esetlegesen bekövetkező
            kényszerhelyzetek után való talpra állás segítése. Válassza ki vállalkozása élethelyzetéhez leginkább illő
            szolgáltatásokat és jelentkezzen a programokra!
          </p>
          <p>
            A projektjei finanszírozására a <a href="./company-offers-private">„Lehetőségeim”</a> oldalon találja az
            államilag támogatott pályázati felhívásokat, hiteltermékeket.
          </p>
        </b-col>
      </b-row>
      <b-row class="info-boxes">
        <b-col cols="12" lg="4" style="position:relative;">
          <div class="info-box info-box-1">
            <img class="ellipse" src="../assets/img/business-development-services/start-ups.svg" />
            <p class="sub-title">Induló vállalkozások</p>
            <ul>
              <li class="subtitle" @click="scrollToUzletiTerv">Üzleti terv</li>
              <li class="subtitle" @click="scrollToAdozasiTanacsok">Adózási tanácsadás</li>
              <li class="subtitle" @click="scrollToInnovativStartup">Innovatív startup</li>
              <li class="subtitle" @click="scrollToVoszPort">Vállalkozásvezetés egyszerűen</li>
            </ul>
          </div>
          <img class="arrow-down d-none d-lg-inline" src="../assets/img/business-development-services/arrow-down.svg" />
        </b-col>
        <b-col cols="12" lg="4" class="info-box-2-wrapper">
          <div class="info-box info-box-2">
            <img class="ellipse" src="../assets/img/business-development-services/developing-businesses.svg" />
            <p class="sub-title">Fejlődő vállalkozások</p>
            <ul>
              <li class="subtitle" @click="scrollToUzletfejlesztes">Üzletfejlesztés</li>
              <li class="subtitle" @click="scrollToTechnologiaiFejlesztes">Technológiafejlesztés</li>
              <li class="subtitle" @click="scrollToDigitaliazacio">Digitalizáció</li>
              <li class="subtitle" @click="scrollToZold">Zöld átállás</li>
              <li class="subtitle" @click="scrollToInnovacio">Innováció</li>
              <li class="subtitle" @click="scrollToKulpiac">Külpiacra lépés</li>
              <li class="subtitle" @click="scrollToVoszPort">Vállalkozásvezetés egyszerűen</li>
            </ul>
          </div>
        </b-col>
        <b-col cols="12" lg="4" style="position:relative;">
          <div class="info-box info-box-1">
            <img class="ellipse" src="../assets/img/business-development-services/mature-businesses.svg" />
            <p class="sub-title">Érett vállalkozások</p>
            <ul>
              <li class="subtitle" @click="scrollToGeneraciovaltas">Generációváltás</li>
              <li class="subtitle" @click="scrollToValsagkezeles">Válságkezelés</li>
              <li class="subtitle" @click="scrollToVoszPort">Vállalkozásvezetés egyszerűen</li>
            </ul>
          </div>
          <img class="arrow-up d-none d-lg-inline" src="../assets/img/business-development-services/arrow-up.svg" />
        </b-col>
      </b-row>
      <b-row class="mb-4 mt-5">
        <b-col sm="12" md="8">
          <h1>Induló vállalkozásoknak</h1>
        </b-col>
      </b-row>
      <div id="uzleti-terv" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Üzleti terv
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">KSH – KKV-tervező</h3>
            <p>
              A Központi Statisztikai Hivatal (KSH) mind az újonnan létrejött vállalkozások, mind a vállalkozás
              indítását tervezők, mind a már működő vállalkozások számára szolgáltatások széles palettáját nyújtja
              döntéseik megalapozásához, ügyintézésük gördülékenyebbé tételéhez. A KSH számos térítésmentes
              szolgáltatást nyújt a vállalkozások számára például szakértői állásfoglalást ad a statisztikai
              osztályozásokkal kapcsolatos besorolási kérdésekbe, illetve segíti a vállalkozásokat a társszervek
              illetékességében való eligazodásában.
            </p>
            <a
              class="services-button-wrapper"
              href="https://www.ksh.hu/kkv/uj-vallalkozast-inditana-vagy-a-regit-inditana-ujra.html"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a tájékoztatásra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">Az európai csereprogram vállalkozók számára</h3>
            <p>
              Az Erasmus – fiatal vállalkozóknak határokon átnyúló csereprogram, amely az új vagy erre törekvő
              vállalkozóknak ad lehetőséget arra, hogy tapasztalt, más, a programban részt vevő országokban
              kisvállalkozást működtető vállalkozóktól tanulhassanak.
            </p>
            <a class="services-button-wrapper" href="https://www.erasmus-entrepreneurs.eu/" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">SEED Alapítvány - Dobbantó Program</h3>
            <p>
              A Dobbantó a nők pénzügyi ismereteinek bővítését tűzte ki céljául, és első szakaszában a vállalkozói
              ismeretek és készségek fejlesztésére helyezi a hangsúlyt. A program legfontosabb eleme a 12 napos
              kompetenciafejlesztő tréning, valamint a mindenki számára nyitott klubesemények.
            </p>
            <a class="services-button-wrapper" href="https://seed.hu/szolgaltatasok/dobbanto/" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">MKIK tájékoztatás</h3>
            <p>
              A törvényben meghatározott, a vállalkozásoknak nyújtott alapszolgáltatásokon – tanácsadás gazdasági,
              pénzügyi, adózási, hitelhez jutási kérdésekben; üzleti partnerkeresés; pályázatfigyelés – kívül a
              gazdasági kamarák kötelezően ellátandó feladatai közé tartozik az egyéni vállalkozói tevékenység
              folytatásához szükséges információkról, az egyéni vállalkozói tevékenység folytatásáról, a képesítéshez,
              valamint a hatósági engedélyhez vagy bejelentéshez kötött gazdasági tevékenységekről való tájékoztatás
              nyújtása. Részletesebb információért a területileg illetékes kamarához szükséges fordulni.
            </p>
            <a class="services-button-wrapper" href="https://mkik.hu/teruleti-kamarak" target="_blank">
              <div>
                <p class="mb-0">Tovább a tájékoztatásra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">EKKV e-learning: Pénzügyi tervezés és finanszírozás</h3>
            <p>
              A modul a vállalatok tudatos pénzügyi tervezését segíti elő üzleti tervvel és különböző finanszírozási
              formák ismertetésével. A modulban megismerkedhet a különböző finanszírozási formákkal: a hitelekkel, az
              állami forrásokkal, a tőkebefektetésekkel és a tőzsdével. A képzésen a tudatos pénzügyi tervezésről is szó
              lesz, továbbá bemutatásra kerül, hogy a különböző célokhoz milyen forrás bevonása a megfelelő.
            </p>
            <a
              class="services-button-wrapper"
              href="https://ekkv.hu/penzugyi-tervezes-es-finanszirozas"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <div id="adozasi-tanacsok" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Adózási tanácsadás
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">NAV Mentor Program</h3>
            <p>
              A Mentor Program célja, hogy a Nemzeti Adó- és Vámhivatal az újonnan alakult adózók jogkövetését
              elősegítse, a helytelen adózási gyakorlat kialakulását megelőzze és az adókötelezettségek teljesítéséhez
              segítséget nyújtson. A mentorálás időtartama a kapcsolatfelvétel kezdeményezésétől számított 6 hónapig
              tart. A Mentor Programban a kezdő egyéni vállalkozók, újonnan alakult cégbejegyzésre kötelezett
              szervezetek, bíróság által nyilvántartott civil szervezetek, valamint ügyvédi irodák és szabadalmi ügyvivő
              irodák vehetnek részt.
            </p>
            <a class="services-button-wrapper" href="https://nav.gov.hu/ugyfeliranytu/mentor_program" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">SZTNH KFI minősítés</h3>
            <p>
              A kutatás-fejlesztési (K+F) tevékenységek minősítésével kapcsolatos feladatokat a KFI törvény
              rendelkezései alapján a Szellemi Tulajdon Nemzeti Hivatala (SZTNH) látja el. Hatósági tevékenység
              keretében a Hivatal előtt kezdeményezhető K+F minősítési eljárások: projektminősítés,
              projektcsoport-minősítés. A Hivatal továbbá megkeresés alapján szakértői tevékenység keretében is adhat
              minősítést. A minősítéssel számos adókedvezmény érhető el biztonságos módon és egyes pályázatok esetén
              kötelező is lehet a megszerzése.
            </p>
            <a
              class="services-button-wrapper"
              href="https://www.sztnh.gov.hu/hu/szakmai-oldalak/kf-minosites#szvk"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a minősítésre</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <div id="innovativ-startup" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Innovatív startup
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">NAK - TechLab program</h3>
            <p>
              A NAK TechLab program a Nemzeti Agrárgazdasági Kamara hosszú távú innovációs programja, mely a magyar
              mezőgazdaság digitális modernizációjára fókuszál; hidat képez az agtech startupok, innovatív vállalkozások
              és a hazai agrárium szereplői között annak érdekében, hogy a digitális megoldások könnyebben és gyorsabban
              elterjedjenek és a jövőben a gazdák rendelkezésesre álljanak. A különböző programok során a Kamara
              támogató környezetet biztosít a startupoknak; legyen szó agrárszakmai tudás megosztásról, üzleti
              mentorálásról, befektetőkkel való összekötésről, vagy validációban nyújtott segítségről.
            </p>
            <a class="services-button-wrapper" href="https://www.naktechlab.hu/" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">Hiventures – EduLab</h3>
            <p>
              A Hiventures Edulab egy olyan országos, illetve régiós szinten is egyedülálló komplexitású, online képzési
              program, amely kifejezetten a korai fázisú startupok, és azok ötletgazdáinak fejlődését szolgálja egy
              változatosan feldolgozott moduláris rendszerben, több csatorna felhasználásával.
            </p>
            <a class="services-button-wrapper" href="https://startup.hiventures.hu/edulab" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <b-row class="mb-4 mt-5">
        <b-col sm="12" md="8">
          <h1>Fejlődő vállalkozásoknak</h1>
        </b-col>
      </b-row>
      <div id="uzleti-fejlesztes" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Üzletfejlesztés
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">EKKV e-learning: Belső és külső kommunikáció</h3>
            <p>
              A modul bemutatja, hogyan lehet az adott vállalat ügyfelei, partnerei és munkatársai felé hatékonyan
              eljuttatni az üzeneteket. A modul első része rendszerezi a különböző digitális kommunikációs csatornákat
              (honlap, blog, hírlevél stb.). A résztvevők megismerhetik a teljes folyamatot: célkitűzés, értékajánlat és
              versenyelőny, digitális eszközök kiválasztása. A modul második része a munkatársakkal folytatott
              kommunikációt taglalja: bemutatásra kerül, hogy stratégiai és operatív szinten miként harmonizálható a
              vállalati kultúra, a belső kommunikáció az üzleti szempontokkal. Kitekintésként jó gyakorlatok kerülnek
              bemutatásra a hatékony megbeszélésekhez, az írásbeli bejelentésekhez, és a pletyka kezeléséhez.
            </p>
            <a class="services-button-wrapper" href="https://ekkv.hu/belso-es-kulso-kommunikacio" target="_blank">
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">EKKV e-learning: HR Kihívások és agilis átalakulás</h3>
            <p>
              A modulban a küldetés és a kultúra kapcsán bemutatásra kerül, hogy mekkora erő rejlik abban, ha a
              munkatársakat a havi béren túl összeköti egy nagy, közös hosszú távú cél, valamint, ha konstruktív
              értékeken alapul a mindennapi viselkedés. További téma a teljesítmény, elsősorban a tehetségek, a vezetői
              utánpótlás és az elkötelezettség felől nézve, praktikus eszközök kerülnek bemutatásra a mérésre és
              értékelésre. A modul foglalkozik a képzési igények meghatározásának alapjával és a személyes célokból
              fakadó igényekkel, továbbá az egyik legújabb HR kihívással, az agilis szervezeti működéssel. A modul
              megkülönbözteti a kötelező és szabadon választott, valamint az egyéni és csoportos képzéseket, és irányt
              mutat a képzések adminisztrációjával kapcsolatban.
            </p>
            <a class="services-button-wrapper" href="https://ekkv.hu/hr-kihivasok-es-agilis-atalakulas" target="_blank">
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">Az európai csereprogram fogadó vállalkozások számára</h3>
            <p>
              Az Erasmus – fiatal vállalkozóknak határokon átnyúló csereprogram, amely az új vagy erre törekvő
              vállalkozóknak ad lehetőséget arra, hogy tapasztalt, más, a programban részt vevő országokban
              kisvállalkozást működtető vállalkozóktól tanulhassanak. A csereprogram számos lehetőséget nyújt a
              résztvevő fogadó vállalkozások számára, mint például együttműködés egy energikus és motivált új
              vállalkozóval, aki innovatív felfogással, új képességekkel és tudással járulhat hozzá vállalkozáshoz;
              nyelvtudás fejlesztéséhez stb.
            </p>
            <a class="services-button-wrapper" href="https://www.erasmus-entrepreneurs.eu/" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">SEED Alapítvány - Lépj szintet! Program</h3>
            <p>
              Személyes és online tudásmegosztó események, egynapos szakmai workshopok, és vállalkozásra szabott
              személyes tanácsadási alkalmak képezik a részét annak a komplex vállalkozásfejlesztési programsorozatnak,
              melyet a SEED Alapítvány kínál díjmenetesen a mikro- és kisvállalkozások számára. A komplex és átfogó
              eseménysorozat keretében olyan gyakorlati tudás szerezhető meg, amely segítséget nyújt a vállalkozói
              források és felhasználásukhoz szükséges tudás feltérképezéséhez és megszerzéshez. A SEED Alapítvány számos
              kompetenciafejlesztő workshopot, képzést is kínál kifejezetten a legkisebb vállalkozások igényeire szabva
              költségtérítéses módon.
            </p>
            <a class="services-button-wrapper" href="https://seed.hu/lepj-szintet/" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <div id="technologiai-fejlesztes" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Technológiafejlesztés
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">EKKV e-learning: Szektoronkénti digitalizáció</h3>
            <p>
              A modul keretében a résztvevők megismerhetik, hogy milyen lehetőségeket és veszélyeket jelent az agrárium,
              az alkatrészgyártás, az építőipar és a vendéglátás számára a digitalizáció. A modulban bemutatásra kerül,
              hogy milyen trendek és technológiák terjednek ma általában a piacon, és milyen szemlélettel, módszerekkel
              tudjuk a lehetőségeket kiaknázni. A modul részletesen és közvetlen példákkal mutatja be, milyen digitális
              eszközök bevezetésével milyen hatás érhető el a 4 legnagyobb KKV szektorban.
            </p>
            <a class="services-button-wrapper" href="https://ekkv.hu/szektoronkenti-digitalizacio" target="_blank">
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">Modern Mintaüzem Program</h3>
            <p>
              A projekt célja a mikro-, kis- és középvállalkozások szervezeti megújulásának és technológiaváltásának
              elősegítése azáltal, hogy országszerte 100 vállalkozáshoz lehet ellátogatni szervezett formában. A
              tevékenység az „egymástól tanulás” módszerrel valósul meg, a vállalkozók első kézből ismerhetik meg a
              piacon jelenlévő más cégek által használt modern megoldásokat. A projekt számos tudásalapú, fejlesztő
              szolgáltatással segíti a kkv-kat például egyedi konzultációval, tanácsadással.
            </p>
            <a class="services-button-wrapper" href="https://www.modem4.hu" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <div id="digitalizacio" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Digitalizáció
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">Modern Vállalkozások Programja</h3>
            <p>
              A Program a hazai vállalkozásokat segíti a digitalizációban, országos, informatikai tanácsadó hálózatot
              működtet. A szakértők segítségével vállalkozása egy átfogó digitális felmérés keretében olyan, személyre
              szabott fejlesztési koncepciót vehet kézhez, amelyben a reális helyzetkép mellett konkrét javaslatokat,
              megoldásokat talál. A Programban több mint 1.100 akkreditált informatikai szállító, 3.000 feletti
              minősített terméke közül válogathatnak az érdeklődők. Uniós forrás digitális beruházásra ma már szinte
              kizárólag a Modern Vállalkozások Programján keresztül érhető el. A Program valamennyi szolgáltatása
              díjmentes.
            </p>
            <a class="services-button-wrapper" href="https://vallalkozzdigitalisan.hu" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">EKKV e-learning: Digitalizáció</h3>
            <p>
              Megismerheti, hogy milyen változásokat okoz a gyorsuló technológiai fejlődés: az aktuális, általános
              hatású digitális trendek gyakorlati példákkal kerülnek alátámasztásra. Megismerkedhet egy egyszerűen
              használható trendelemzési módszertannal, amely segítségével egy új trendet, vagy technológiát 1 órán belül
              bárki a saját vállalkozására alkalmazhat. Külön fókuszt kap a digitális ügyfélélmény, az
              ügyfélszolgálatok, értékesítési pontok esetében. A modulban bemutatásra kerül továbbá az adatalapú vezetés
              4 szintje és a lehetséges alkalmazási területeik.
            </p>
            <a class="services-button-wrapper" href="https://ekkv.hu/digitalizacio" target="_blank">
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <div id="zold" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Zöld átállás
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">EKKV e-learning: A fenntartható vállalkozás</h3>
            <p>
              Miért és hogyan jelenjen meg a fenntarthatóság a vállalkozásom életében?
              <br />
              <br />
              A modul vázolja a fenntarthatóság hátterét: az emberi tevékenység környezeti hatásait a vállalati
              felelősséget általában, és a jogszabályokat. Kitér a támogató intézményekre, és a pályázati-finanszírozási
              lehetőségekre is. Az online képzésen közérthetően bemutatásra kerül, milyen aspektusokban lehet értékelni
              a fenntarthatóságot és a felelős irányítást (ESG). A modul ismerteti a kulcsfogalmakat is:
              életciklus-szemlélet, körforgásos gazdaság, ökodizájn, társadalmi felelősségvállalás, társadalmi
              vállalkozások, zöldremosás.
            </p>
            <a class="services-button-wrapper" href="https://ekkv.hu/fenntarthato-vallalkozas" target="_blank">
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <div id="innovacio" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Innováció
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">EKKV e-learning: Üzleti innováció</h3>
            <p>
              A modul ismerteti, hogy mi minősül vállalati innovációnak és kutatás-fejlesztésnek és bemutatja a témában
              érintett hazai intézményeket. A modul segítségével megtudhatja, hogyan generáljon innovációs projekteket
              vállalkozásában: bemutatja a leghasznosabb innovációs módszertanokat és nemzetközi modelleket, és tanácsot
              ad az inspirációra és az ötletgenerálásra.
            </p>
            <a class="services-button-wrapper" href="https://ekkv.hu/uzleti-innovacio" target="_blank">
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">Horizont Európa Nemzeti Kapcsolattartói hálózat (NCP)</h3>
            <p>
              Az NCP-k fő feladata, hogy a Horizont Európa struktúráját követve, az egyes alprogramokhoz,
              partnerségekhez és missziókhoz kapcsolódva magas színvonalú, professzionális és ingyenesen elérhető
              támogatást nyújtsanak a potenciális pályázók (kutatóintézetek, egyetemek, vállalatok, nonprofit
              intézmények, egyéni kutatók) részére.
            </p>
            <a
              class="services-button-wrapper"
              href="https://nkfih.gov.hu/hivatalrol/nemzetkozi-kapcsolatok/horizont-europa/nemzeti-kapcsolattarto-pontok"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">SZTNH IP scan (szellemi vagyon diagnózis)</h3>
            <p>
              Térítésmentes tanácsadás kis-és középvállalkozások szellemivagyon-gazdálkodásának elősegítésére. Az IP
              Scan szolgáltatás testre szabottan ad támpontokat a vállalkozások számára a szellemi vagyonuk jogi
              védelmének lehetőségeiről. A szolgáltatás igénybevétele olyan innovatív vállalkozásoknak ajánlott, amelyek
              az utóbbi években a kutatás-fejlesztés területén lépéseket tettek, és úgy gondolják, hogy a hatékony
              üzletmenet érdekében fel kívánják használni, illetve az eddiginél hatékonyabban kívánják felhasználni a
              szellemitulajdon-védelem eszköztárát.
            </p>
            <p>
              Az SZTNH szerzői jogi és ipajogvédelmi tanfolyamokat, továbbá számos szolgáltatást is kínál a
              vállalkozások számára költségtérítéses módon.
            </p>
            <a
              class="services-button-wrapper"
              href="https://www.sztnh.gov.hu/hu/vallalkozoknak/ip-scan-szellemivagyon-diagnozis"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <div id="kulpiac" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Külpiacra lépés
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">HEPA - Exportstratégiai konzultáció, Exportérettség vizsgálata</h3>
            <p>
              A konzultáció során a HEPA munkatársai felmérik az adott vállalkozást és minősítik az exportfejlettségi
              helyzetét illetően, továbbá áttekintik a következő 1-3 éves exportpiaci terveit. A szolgáltatás része a
              vállalkozás helyzetének elemzése, a termékek/szolgáltatások exportképességének felmérése, potenciális
              célpiacok kijelölése, prioritások meghatározása és értékesítési akcióterv kidolgozása. A HEPA szakértő
              munkatársai a célok és eredmények függvényében adnak javaslatot a vállalatoknak az exportsikerek érdekében
              történő elmozdulási irányokra és egy közös akciótervet dolgoznak ki a következő lépések kapcsán, amely a
              vállalkozás következő 1-3 éves stratégiáját támogatja a külpiacokon.
            </p>
            <a
              class="services-button-wrapper"
              href="https://hepa.hu/szolgaltatasok/exporterettseg-vizsgalata-exportstrategiai-konzultacio"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">EKKV e-learning: Nemzetközi kapcsolatok és terjeszkedés</h3>
            <p>
              Megismerheti, hogy miért és hogyan érdemes üzletet kötni Magyarországon kívül. A modul bemutatja a tipikus
              exportpiacokat, a kereskedelmi trendeket, és a különböző külpiacra lépési formákat a klasszikus exporttól
              a platformgazdaságig. A modul számba veszi a motiváló és hajtóerőként funkcionáló tényezőket éppúgy, mint
              a lehetséges akadályokat. További blokkok: az EU és a magyar állam exportszabályozása és támogatásai, az
              Unión kívülre irányuló kereskedelmet támogató eszközök, a külpiaci üzletkötés lépései és fortélyai, a
              lehetséges kockázatok kezelése.
            </p>
            <a
              class="services-button-wrapper"
              href="https://ekkv.hu/nemzetkozi-kapcsolatok-es-terjeszkedes"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">Enterprise Europe Network – Magyarország</h3>
            <p>
              Az Enterprise Europe Network a kkv-k nemzetközi piacra lépését 60 országban, több mint 3000 munkatársának
              kapcsolatrendszerével, piacismeretével támogatja. A naprakész piaci információkon túl nemzetközi
              partnerkereső rendezvények és konkrét üzleti lehetőségek is elérhetőek. Célzott partnerkeresési
              szolgáltatással azonosítják és ellenőrzik a potenciális üzleti partnereket.
            </p>
            <a
              class="services-button-wrapper"
              href="https://hepa.hu/szolgaltatasok/nemzetkozi-partnerkereseses-kozvetites-promocio"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">Exportakadémia</h3>
            <p>
              A HEPA Exportakadémia Képzési Központ által szervezett exportfejlesztési képzések felkészítik az exportáló
              vagy export iránt érdeklődő vállalkozások képviselőit a sikeres külpiacra lépésre, stratégiai szemlélet
              formálásával, külpiaci információk átadásával, valamint tárgyalási és menedzsment képességek
              fejlesztésével.
            </p>
            <a class="services-button-wrapper" href="https://hepa.hu/szolgaltatasok/export-akademia" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">HEPA - Külpiaci innovációs tanácsadás</h3>
            <p>
              A HEPA innovációs tanácsadást ajánl azoknak a kis-, közép- és nagyvállalatoknak, akik innovációs
              képességük fejlesztésével szeretnék növelni versenyképességüket. A felmérés eredményeként meghatározható a
              vállalat innováció-orientáltságának mértéke, valamint a fejlesztésre váró területek.
            </p>
            <a
              class="services-button-wrapper"
              href="https://hepa.hu/szolgaltatasok/kulpiaci-innovacios-tanacsadas"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <b-row class="mb-4 mt-5">
        <b-col sm="12" md="8">
          <h1>Érett vállalkozásoknak</h1>
        </b-col>
      </b-row>
      <div id="generaciovaltas" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Generációváltás
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">EKKV e-learning: A közvetlen vezetés átadása</h3>
            <p>
              A modul bemutatja, hogy mit jelent egy vállalat éléről visszavonulni, melyet nem ritkán egy élet
              munkájával épített fel a vezető. A modul külön vizsgálja a személyeket (ki, kinek és kinek a
              segítségével), a tartalmat (a vállalat egyes területei és a vezetői feladatok, módszerek és lépések). Az
              e-learning egy egész blokkot szentel a bizalom és az elengedés lélektani hátterének, végül az átadás
              praktikus nehézségeit veszi sorra az átadó és az átvevő vezető szemszögéből, majd felvázolja a lehetséges
              megoldásokat ezekkel kapcsolatban.
            </p>
            <a class="services-button-wrapper" href="https://ekkv.hu/a-kozvetlen-vezetes-atadasa" target="_blank">
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">Evolúció - Generációváltás</h3>
            <p>
              A cégátadás és utódlás lebonyolítása hosszútávú stratégiai és pénzügyi tervezést, tudatos vállalkozói
              hozzáállást igényel, azonban a hazai vállalkozói kultúrában még nem alakultak ki erre vonatkozó
              gyakorlatok. Az EVOLÚCIÓ – Megújuló Vállalkozások Programjának célja, hogy fejlessze a vállalkozásokat
              támogató jogi és üzleti szolgáltatások piacát, valamint díjmentesen igénybe vehető szakértői tanácsadással
              felkészítse a hazai kkv-kat az előttük álló generációváltás folyamatára.
            </p>
            <a class="services-button-wrapper" href="https://generaciovaltas.evolucio.ifka.hu/" target="_blank">
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>
      <div id="valsagkezeles" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Válságkezelés
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" lg="6" class="services-wrapper border-right mt-4">
            <h3 class="title">EKKV e-learning: Változásmenedzsment</h3>
            <p>
              A modulban a résztvevő folyamatot és módszereket ismerhet meg, hogy bármilyen változást hatékonyan tudjon
              menedzselni a felelős vezető és az érintettek. A stratégia, a résztvevők és a kommunikáció témáit
              megkülönböztetve, Kotter 8 lépéses folyamatát használva a generációváltás specifikumait is bemutatja. A
              modul második része a tervezett és a 'vis maior' változások érzelmi fázisaival foglalkozik. Megtudhatja,
              hogy mi kell ahhoz, hogy a változás sikeresen végbe menjen a szervezetben, külön kiemelve a vezetői
              feladatokat.
            </p>
            <a class="services-button-wrapper" href="https://ekkv.hu/valtozasmenedzsment" target="_blank">
              <div>
                <p class="mb-0">Tovább a modulra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
          <b-col cols="12" lg="6" class="services-wrapper border-left mt-4">
            <h3 class="title">Evolúció – Második esély</h3>
            <p>
              A Második esély program speciális cégdiagnosztikával, valamint szakértők bevonásával segíti a válságba
              jutott vállalkozások fejlesztését, működésük átalakítását. A program keretében egy olyan gazdálkodási
              cégszűrési- és válságelőrejelzési módszertannal ismerkedhetnek meg a résztvevők, amelynek segítségével
              lehetővé válik a válság jeleinek korai előrejelzése.
            </p>
            <a
              class="services-button-wrapper"
              href="https://evolucio.ifka.hu/hu/page/masodik-esely-program"
              target="_blank"
            >
              <div>
                <p class="mb-0">Tovább a programra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </a>
          </b-col>
        </b-row>
      </div>

      <div id="voszport" class="my-5 pb-5">
        <b-row class="mb-4">
          <b-col cols="12" lg="6">
            <h2>
              Vállalkozásvezetés egyszerűen
            </h2>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="services-wrapper border-right mt-4">
            <h3 class="title">VOSZPort</h3>
            <p>
              A Vállalkozók és Munkáltatók Országos Szövetsége álmodta meg a VOSZPort alkalmazást, mely kifejezetten
              azért készült, hogy a mikro-, kis- és középvállalkozások operatív folyamatait segítse. Az alkalmazás
              segítségével, többek között, könnyen átláthatja a cége pénzügyi helyzetét, vállalkozásfejlesztési
              lehetőségeit és értesülhet a hazai- illetve külföldi hírekről, fontos tudnivalókról. A VOSZPort piactere,
              pedig olyan alkalmazásokat, weboldalakat kínál Önnek, amivel gyorsabbá teheti a napi teendőit.
            </p>
            <div class="services-button-wrapper cursor-pointer" role="presentation" @click="goToVoszPort">
              <div>
                <p class="mb-0">Tovább a portálra</p>
              </div>
              <div>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 0L9.885 2.115L18.255 10.5H0V13.5H18.255L9.885 21.885L12 24L24 12L12 0Z" fill="#00903C" />
                </svg>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </b-container>
    <b-modal id="voszport-terminated-modal" hide-header hide-footer centered title="" size="xl">
      <div class="d-block mb-5 p-2 pt-0 ">
        <h1 class="d-flex justify-content-center title mb-5"><strong> Sikertelen bejelentkezés!</strong></h1>
        <p class="ml-2 mr-2 d-flex justify-content-center">
          A VOSZPort oldali felhasználó felfüggesztésre került! Ezért a belépés a VOSZPort felületére nem lehetséges.
          Kérjük, vegye fel a kapcsolatot a voszport.hu oldalon az „Írjon nekünk” funkcióval, hogy további segítséget
          nyújthassunk Önnek.
          <br />
          <br />
          Üdvözlettel a VOSZPort csapata!
        </p>
        <div class=" d-flex justify-content-center">
          <b-button class="col-3" @click="closeTerminatedModal">Rendben</b-button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as VoszportApi from '../api/voszport'
export default {
  name: 'Sustainability',
  computed: {
    ...mapGetters(['isAuthenticated', 'getUser'])
  },
  methods: {
    scrollToVoszPort() {
      const el = document.getElementById('voszport')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToUzletiTerv: function() {
      const el = document.getElementById('uzleti-terv')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToAdozasiTanacsok: function() {
      const el = document.getElementById('adozasi-tanacsok')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToInnovativStartup: function() {
      const el = document.getElementById('innovativ-startup')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToUzletfejlesztes: function() {
      const el = document.getElementById('uzleti-fejlesztes')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToTechnologiaiFejlesztes: function() {
      const el = document.getElementById('technologiai-fejlesztes')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToDigitaliazacio: function() {
      const el = document.getElementById('digitalizacio')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToZold: function() {
      const el = document.getElementById('zold')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToInnovacio: function() {
      const el = document.getElementById('innovacio')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToKulpiac: function() {
      const el = document.getElementById('kulpiac')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToGeneraciovaltas: function() {
      const el = document.getElementById('generaciovaltas')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    scrollToValsagkezeles: function() {
      const el = document.getElementById('valsagkezeles')
      el.scrollIntoView({ behavior: 'smooth' })
    },
    openLoginModal() {
      this.$root.$emit('bv::show::modal', 'login-modal')
    },
    async goToVoszPort() {
      if (!this.isAuthenticated) {
        window.open('https://voszport.hu', '_blank')
        return
      }
      const status = await this.getStatus(this.getUser.email)
      if (status === 'EXIST') {
        const redirectUrl = await this.getLoginRedirectUrl(this.getUser.email)
        window.open(redirectUrl, '_blank')
      }

      if (status === 'NOT_EXIST') {
        const redirectUrl = await this.getRegistRedirectUrl(this.getUser._id)
        window.open(redirectUrl, '_blank')
      }

      if (status === 'SUSPENDED' || status === 'TEMPORALLY_DISABLED') {
        this.openTerminatedModal()
      }

      if (status === 'NO_RESPONSE') {
        window.open('https://voszport.hu', '_blank')
      }
    },
    async getStatus(email) {
      try {
        const status = await VoszportApi.getStatus(email)
        return status
      } catch (error) {
        console.log(error)
      }
    },
    async getLoginRedirectUrl(email) {
      try {
        const redirectUrl = await VoszportApi.getLoginRedirectUrl(email)
        return redirectUrl
      } catch (error) {
        console.log(error)
      }
    },
    async getRegistRedirectUrl(userId) {
      try {
        const redirectUrl = await VoszportApi.getRegistRedirectUrl(userId)
        return redirectUrl
      } catch (error) {
        console.log(error)
      }
    },
    openTerminatedModal() {
      this.$root.$emit('bv::show::modal', 'voszport-terminated-modal')
    },
    closeTerminatedModal() {
      this.$root.$emit('bv::hide::modal', 'voszport-terminated-modal')
    }
  }
}
</script>

<style scoped>
.info-boxes {
  margin-top: 90px;
}

.arrow-down {
  position: absolute;
  right: -15px;
}
.arrow-up {
  position: absolute;
  left: -15px;
}

.info-box {
  color: #636e72;
  background: #d9eee2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  padding: 64px;
  padding-left: 20px;
  padding-right: 20px;
}

.info-box-1 {
  border-radius: 60px 0px;
}
.info-box-2 {
  border-radius: 0px 60px;
}

.info-box-2-wrapper {
  margin-top: 225px;
}

.info-box ul {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  list-style-type: none;
}
.info-box li {
  cursor: pointer;
  margin-top: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 24px;
  width: 200px;
  height: 48px;
  background: #ffffff;
  border-radius: 16px;
}

.ellipse {
  position: absolute;
  top: -70px;
  left: 135px;
}
.ellipse-2 {
  position: absolute;
  top: -46px;
}
.sub-title {
  text-align: center;
  font-weight: bold;
  color: #636e72;
}

.title {
  color: #00903c;
  margin-bottom: 24px;
}

.services-wrapper {
  background: #f2f8fa;
  padding: 24px;
  padding-top: 32px;
  padding-bottom: 32px;
}

.border-right {
  border-right: 12px solid white !important;
}

.border-left {
  border-left: 12px solid white !important;
}

.services-button-wrapper {
  margin-top: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 65%;
  background: #f2f8fa;
  text-decoration: none;
  font-weight: 700;
  color: #00903c;
}

@media (max-width: 992px) {
  .ellipse {
    position: absolute;
    top: -70px;
    left: 37%;
  }

  .info-box-2-wrapper {
    margin-top: 0px;
  }

  .info-box {
    margin-bottom: 80px;
  }

  .border-right {
    border-right: 0px solid white !important;
  }

  .border-left {
    border-left: 0px solid white !important;
  }
}

.subtitle:hover {
  color: white;
  background-color: #00903c;
}
</style>
